import type { TourDefinition } from '../training/tours';

/**
 * Тур майстра перенесення даних. Ідентифікатор: 'migration-wizard'.
 * Цілі — атрибути data-tour на сторінці завдання (/migration/new/:source, /migration/jobs/:id): і вміст поточного кроку,
 * і рядки панелі «Стан перенесення» праворуч (вони є на кожному кроці, тож підказка знаходить ціль завжди).
 */
export const MIGRATION_WIZARD_TOUR_ID = 'migration-wizard';

export const MIGRATION_WIZARD_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Майстер перенесення',
  summary: 'Джерело й доступ, параметри й відповідність працівників, пробний прогін і проблеми, застосування з підтвердженням, звірка, видалення файла вивантаження.',
  missingHint: 'Відкрийте завдання перенесення в розділі «Перенесення даних» — підказки прив’яжуться до кроків майстра.',
  steps: [
    {
      id: 'access',
      target: 'migration-access',
      title: 'Джерело й доступ',
      body: 'Для Asana й Clockify потрібен ключ доступу адміністратора: він зберігається зашифровано, видно лише останні 4 символи. «Перевірити з’єднання» покаже обліковий запис і робочі простори. Для УП і таблиць — файл вивантаження: JSON або CSV у кодуванні UTF-8.',
      placement: 'bottom',
    },
    {
      id: 'params',
      target: 'migration-params',
      title: 'Параметри й відповідність працівників',
      body: 'Оберіть, що переносити. Працівників зіставляємо за поштою; кого не знайдено — вкажіть вручну: працівник ЄРС або службовий користувач. Параметри повністю замінюють попередні, тож після зміни потрібен новий пробний прогін.',
    },
    {
      id: 'dry-run',
      target: 'migration-dry-run',
      title: 'Пробний прогін і проблеми',
      body: 'Пробний прогін нічого не змінює в ЄРС: показує план (що буде створено, оновлено, пропущено) і реєстр проблем із рекомендаціями. Опрацюйте помилки й попередження до застосування.',
    },
    {
      id: 'apply',
      target: 'migration-apply',
      title: 'Застосування з підтвердженням',
      body: 'Застосування доступне після успішного пробного прогону з поточними параметрами. Повторне застосування оновлює змінене й не дублює перенесене; правки, зроблені вже в ЄРС, не перезаписуються.',
    },
    {
      id: 'reconciliation',
      target: 'migration-reconciliation',
      title: 'Звірка',
      body: 'Протокол звірки порівнює кількості й години в джерелі та в ЄРС за проєктами, місяцями й працівниками. Розбіжність понад допуск позначено червоним і текстом «Розбіжність».',
    },
    {
      id: 'file',
      target: 'migration-file',
      title: 'Видалення файла вивантаження',
      body: 'Файли вивантажень містять персональні дані. Після застосування й успішної звірки видаліть файл із сервера — повне вивантаження зберігається в захищеній папці Google Drive фірми.',
    },
  ],
};
